import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {
  loader: HTMLIonLoadingElement;

  constructor(
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public modalCtrl:ModalController,
    public router:Router
  ) {}

  async showAuthAlert(){
    await(await this.alertCtrl.create({
      header:'',
      message:'Потрібна реєстрація у Resta.',
      buttons:[
        // {
        //   text:'Пізніше'
        // },
        {
          text:'OK',
          handler:() => {
            this.modalCtrl.dismiss();
            this.router.navigate(['/sign-up']);
          },
        }
      ],
    })).present();
  }

  async startLoader(text: string = '', duration: number = 60000) {
    this.loader = await (this.loadingCtrl.create({ message: text, duration: duration }));
    this.loader.present();
  }

  async showAlert(header: string = '', message: string = '') {
    await (
      await this.alertCtrl.create({
        header:header,
        message:message,
        buttons:["OK"]
      })
    ).present();
  }

  async updateUrl(id) {
    window.location.href = 'http://locahost:8100/restaurant/' + id;
  }
    
  async showError(message: string) {
    await (await this.alertCtrl.create({
      header: 'Помилка',
      message: message,
      buttons: ['OK']
    })).present();
  }
}
